import React from 'react';
import { useMachinesList } from './presenter';
import { MachinesListView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';
import { useConfirm } from '../../../components/ui/ConfirmDialog';
import { useToast } from '../../../components/ui/Toaster';

type Props = {
  navigate: (r: Route) => void;
};

const MachinesIndexPage: React.FC<Props> = ({ navigate }) => {
  const vm = useMachinesList();
  const confirm = useConfirm();
  const toast = useToast();

  return (
    <MachinesListView
      data={vm.items}
      total={vm.total}
      page={vm.page}
      pageSize={vm.pageSize}
      setPage={vm.setPage}
      setPageSize={vm.setPageSize}
      query={vm.query}
      setQuery={vm.setQuery}
      loading={vm.loading}
      error={vm.error}
      onCreate={() => navigate({ name: 'machines/create' })}
      onView={id => navigate({ name: 'machines/view', params: { id: String(id) } })}
      onEdit={id => navigate({ name: 'machines/update', params: { id: String(id) } })}
      onDelete={async id => {
        const ok = await confirm({ title: 'Delete Machine', message: 'Are you sure you want to delete this machine?', confirmText: 'Delete', variant: 'destructive' });
        if (!ok) return;
        await vm.remove(String(id));
        toast.success('Machine deleted');
      }}
    />
  );
};

export default MachinesIndexPage;
